import { Component, OnInit } from "@angular/core";
import { LoggedUser } from "../auth/logged-user.model";
import { AuthService } from "../auth/auth.service";
import { TranslateService } from "@ngx-translate/core";
import { Translations } from "../localization/translations.service";
import { Routes, Router } from "@angular/router";
import { SidebarService } from "./sidebar.service";

const misc: any = {
  navbar_menu_visible: 0,
  active_collapse: true,
  disabled_collapse_init: 0,
};

declare const $: any;
const body = document.getElementsByTagName("body")[0];

@Component({
  selector: "app-sidebar-cmp",
  templateUrl: "sidebar.component.html",
  styleUrls: ["./sidebar.component.css"],
})
export class SidebarComponent implements OnInit {
  public menuItems: any[];
  public loggedUser: LoggedUser;
  public userName: string;
  public userInitials: string;
  public initialsColor: string;

  constructor(
    private authService: AuthService,
    private sidebarService: SidebarService,
    public t10s: Translations,
    public translateService: TranslateService
  ) {}

  private ROUTES: Routes;
  private router: Router;

  minimizeSidebar() {
    const body = document.getElementsByTagName("body")[0];

    if (misc.sidebar_mini_active === true) {
      body.classList.remove("sidebar-mini");
      misc.sidebar_mini_active = false;
    } else {
      setTimeout(function () {
        body.classList.add("sidebar-mini");

        misc.sidebar_mini_active = true;
      }, 300);
    }

    // we simulate the window Resize so the charts will get updated in realtime.
    const simulateWindowResize = setInterval(function () {
      window.dispatchEvent(new Event("resize"));
    }, 180);

    // we stop the simulation of Window Resize after the animations are completed
    setTimeout(function () {
      clearInterval(simulateWindowResize);
    }, 1000);
  }

  isMobileMenu() {
    if ($(window).width() > 991) {
      return false;
    }
    return true;
  }

  ngOnInit() {
    this.authService.getLoggedUserListener().subscribe((result: any) => {
      if (!result) {
        return;
      }

      this.loggedUser = result;
      this.setUserName(this.loggedUser);
    });
    this.loggedUser = this.authService.getLoggedUser();
    this.setUserName(this.loggedUser);

    const storageRoutes = localStorage.getItem("routes");

    if (storageRoutes) this.ROUTES = JSON.parse(storageRoutes);

    this.sidebarService.getMenusForLoggedUser().then((routes) => {
      this.ROUTES = routes;
      this.menuItems = this.ROUTES;
      localStorage.setItem("routes", JSON.stringify(routes));
    });
  }

  setUserName(loggedUser: LoggedUser): void {
    if (!loggedUser.displayName) {
      return;
    }

    const commaIndex = loggedUser.displayName.indexOf(",");
    if (commaIndex > 0) {
      loggedUser.displayName = `${loggedUser.displayName.substring(
        commaIndex + 2
      )} ${loggedUser.displayName.substring(0, commaIndex)}`;
    }

    const splittedName = loggedUser.displayName.split(" ");
    const fName = splittedName[0];
    const lName = splittedName[splittedName.length - 1];

    this.userName = fName !== lName ? `${fName} ${lName}` : fName;
    this.userInitials =
      fName !== lName
        ? fName.substring(0, 1) + lName.substring(0, 1)
        : fName.substring(0, 1);

    this.setInitialsColor(fName);
  }

  setInitialsColor(fName: string): void {
    const fNameVal = Math.round(((fName.charCodeAt(0) - 64) / 26) * 3);

    this.initialsColor = `color${fNameVal}`;
  }

  onLogout(): void {
    this.authService.logout();
  }

  translate(language) {
    localStorage.setItem("language", language);
    this.translateService.use(language);
    body.classList.add("sidebar-mini");
    document.location.reload();
  }

  minimizeTranslate() {
    body.classList.remove("sidebar-mini");

    if ($(window).width() < 991) {
      if (localStorage.getItem("language") == "en") {
        this.translate("pt_br");
      } else {
        this.translate("en");
      }
    }
  }
}
